module.exports = "/fonts/bariol_regular-webfont.woff?a5bf2a8e0c1f630355e13442ce83df48";